import { put, call } from 'redux-saga/effects';
import * as API from '../../services/api';
import actionTypes from '../actionTypes';

export function* getDealMessages({ dealId }) {
  try {
    const messages = yield call(API.getDealMessages, dealId);
    yield put({ type: actionTypes.DEAL_MESSAGES_GET_SUCCESS, messages });
  } catch (error) {
    yield put({ type: actionTypes.DEAL_MESSAGES_GET_ERROR, error });
  }
}

export function* sendDealMessage({ message }) {
  try {
    const result = yield call(API.sendDealMessage, message);
    if (result.error) {
      yield put({
        type: actionTypes.DEAL_MESSAGE_SEND_ERROR,
        error: result.error,
      });
    } else {
      yield put({
        type: actionTypes.DEAL_MESSAGE_SEND_SUCCESS,
        message: result,
      });
    }
  } catch (error) {
    yield put({ type: actionTypes.DEAL_MESSAGE_SEND_ERROR, error });
  }
}

export function* updateDealMessage({ dealId, messageId, message }) {
  try {
    const result = yield call(
      API.updateDealMessage,
      dealId,
      messageId,
      message
    );
    if (result.id) {
      yield put({
        type: actionTypes.DEAL_MESSAGE_UPDATE_SUCCESS,
        message: result,
      });
    } else {
      yield put({ type: actionTypes.DEAL_MESSAGE_UPDATE_ERROR });
    }
  } catch (error) {
    yield put({ type: actionTypes.DEAL_MESSAGE_UPDATE_ERROR, error });
  }
}

export function* deleteDealMessage({ dealId, messageId }) {
  try {
    yield call(API.deleteDealMessage, dealId, messageId);
    yield put({ type: actionTypes.DEAL_MESSAGE_DELETE_SUCCESS, messageId });
  } catch (error) {
    yield put({ type: actionTypes.DEAL_MESSAGE_DELETE_ERROR, error });
  }
}



// WEBPACK FOOTER //
// src/redux/sagas/dealMessages.js